import {Box, Paper, Typography} from "@mui/material"
import DataGridTable from "../../../../components/Table/data-grid-table"
import FormSectionAccordion from "../../../../components/FormSectionAccordion"
import React, {useEffect, useMemo, useState} from "react"
import {dispatchSnackbar} from "../../../../components/SnackBar/snackbar-bus"
import MotorService from "../../../../../services/motor-service"
import StatusBadge from "../../../../components/StatusBadge"
import {dispatchDuplaConfirmacao} from "../../../../components/DuplaConfirmacao/DuplaConfirmacaoBus"
import {useNavigate} from "react-router-dom"
import PropTypes from "prop-types"
import {createColumnsOCR} from "./ocr-const"
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded"

const OcrTableComponent = ({paginaCadastroOCR, source}) => {
    const [loadingTableOCR, setLoadingTableOCR] = useState(false)
    const [rowsOCR, setRowsOCR] = useState([])
    const [ocrStatus, setOcrStatus] = useState([])
    const service = useMemo(() => new MotorService(), [])
    const navigate = useNavigate()

    useEffect(() => {
        loadCadastrosOCR()
    }, [])

    const iniciaCadastroOCR = (ocrID) => {
        navigate(paginaCadastroOCR, {
            state: {
                origem: 'OCR',
                ocrID: ocrID
            }
        })
    }

    const removeOCR = (id) => {
        setLoadingTableOCR(true)
        service.deleteCadastroOCR(id)
            .then(() => {
                dispatchSnackbar("Cadastro de OCR removido com sucesso", "success")
            })
            .catch((error) => {
                dispatchSnackbar(`Erro ao eliminar o cadastro do OCR: ${error}`, "error")
            })
            .finally(() => {
                setLoadingTableOCR(false)
                loadCadastrosOCR()
            })
    }

    const handleDeleteOCR = (ocrID) => {
        dispatchDuplaConfirmacao({
            title: "Excluir cadastro de OCR",
            open: true,
            confirmAction: () => removeOCR(ocrID),
        })
    }

    const ocrStatusBadge = (number, label, color) => (
        <Box
            sx={{
                ml: 2,
                display: "flex",
                alignItems: "center",
                gap: 1,
            }}
        >
            <StatusBadge
                label={`${number}`}
                radius={1}
                backgroundColor={color}
                fontColor="primary"
            />
            <Typography
                variant="body2"
                color="common.white"
                sx={{
                    ml: 1,
                    fontSize: 14,
                    fontWeight: 400,
                }}
            >
                {label}
            </Typography>
        </Box>
    )

    const columnsOCR = useMemo(
        () => createColumnsOCR(iniciaCadastroOCR, handleDeleteOCR),
        [iniciaCadastroOCR, handleDeleteOCR]
    )

    const loadCadastrosOCR = () => {
        setLoadingTableOCR(true)
        service.loadCadastrosOCR(source)
            .then((response) => {
                const {body} = response
                const list = body.map((obj, index) => ({...obj, id: index}))
                setRowsOCR(list)

                const statusCount = list.reduce(
                    (acc, {Status}) => {
                        acc[Status] = (acc[Status] || 0) + 1
                        return acc
                    },
                    {
                        READING: 0,
                        DONE: 0,
                        ERROR: 0,
                    }
                )

                setOcrStatus([
                    {color: "warning", label: "Em andamento", number: statusCount.READING},
                    {color: "#2BCE95", label: "Leitura concluída", number: statusCount.DONE},
                    {color: "error", label: "Erros", number: statusCount.ERROR},
                ])
            })
            .catch(() => {
                dispatchSnackbar("Erro ao carregar os registros do OCR!", "error")
            })
            .finally(() => {
                setLoadingTableOCR(false)
            })
    }

    return <FormSectionAccordion
        disableBorder
        disableIcon
        iconCallbackFunction={<RefreshRoundedIcon/>}
        callbackFunction={loadCadastrosOCR}
        title={"DOCUMENTOS"}
        header={
            <>
                {ocrStatus.map((item) =>
                    ocrStatusBadge(item.number, item.label, item.color)
                )}
            </>
        }
        defaultOpen={true}>
        <Paper sx={{p: 3, borderRadius: 0}}>
            <Box
                sx={{
                    flex: 1,
                    overflowX: "auto",
                    width: "100%",
                    display: "block",
                }}
            >
                <DataGridTable
                    columns={columnsOCR}
                    rows={rowsOCR}
                    pagination={[5, 25, 50]}
                    disableDeleteColumn
                    pageSize={5}
                    pagitaion
                    loading={loadingTableOCR}
                    resetKey={`cadastro-motor-ocr`}
                />
            </Box>
        </Paper>
    </FormSectionAccordion>
}

OcrTableComponent.propTypes = {
    paginaCadastroOCR: PropTypes.string,
    source: PropTypes.string,
}

export default OcrTableComponent